<template>
  <div style="height: calc(100vh - 196px);">
    <vxe-toolbar
      id="toolbarId"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button v-if="electronicReceipt_search_button" @click="funcFilter"
          >查询</el-button
        >
        <el-button
          v-if="electronicReceipt_statusQuery_button"
          @click="statusQuery"
          >更新申请结果</el-button
        >
        <el-button
          v-if="getLimit('electronicReceipt_multi_apply')"
          @click="funcMultiApply()"
          >批量申请</el-button
        >
        <el-button
          v-if="getLimit('electronicReceipt_download_button')"
          @click="PDFDownload()"
          >下载电子回单</el-button
        >
        <el-button
          v-if="getLimit('electronicReceipt_export_button')"
          @click="funcExport()"
          >导出</el-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="260"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payTypeName"
          title="支付类型"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.payType" placeholder="请选择" clearable>
            <el-option
              v-for="item in payTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderDetailNumber"
          title="运输单号"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderDetailNumber"
            placeholder="运输单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="outTradeNo"
          title="支付流水号"
          min-width="260"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.outTradeNo"
            placeholder="支付流水号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderNo"
          title="网商订单号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderNo"
            placeholder="网商订单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 新增实际承运人托运人 -->
      <vxe-table-column>
        <vxe-table-column
          field="driverName"
          title="实际承运人"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentName"
          title="托运人"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipmentName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="receiptNo"
          title="电子回单编号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.receiptNo"
            placeholder="电子回单编号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="amount"
          title="金额"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.amountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.amountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="status"
          title="状态"
          min-width="100"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'status')
          "
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.status" placeholder="请选择" clearable>
            <el-option
              v-for="item in parentData.statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="创建时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" width="150px" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="electronicReceipt_show_button && scope.row.status === '02'"
            effect="dark"
            content="查看回单"
            placement="top"
          >
            <vxe-button type="text" @click="showElectronicReceipt(scope.row)">
              <i class="el-icon-paperclip" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="electronicReceipt_reapply_button && scope.row.status === '03'"
            effect="dark"
            content="重新申请"
            placement="top"
          >
            <vxe-button type="text" @click="reapplyReceiptStatus(scope.row)">
              <i class="el-icon-thumb" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <el-dialog
      title="失败信息"
      :visible.sync="dialogTableVisible"
      class="abow_dialog"
    >
      <el-table :data="errorData" height="100%" border>
        <el-table-column property="code" label="订单号" width="290" />
        <el-table-column property="msg" label="错误描述" width="300" />
      </el-table>
    </el-dialog>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import {
  mybankElectronicReceipt,
  electronicReceiptQuery,
  mybankElectronicReceiptInfo,
  downLoadFile,
  applyMultiBatch
} from "@/api/InternetBanking";
import { getLimit } from "@/utils/getLimit.js";
export default {
  name: "MerchantList",

  data() {
    return {
      /**
       * data 中只定义变量，赋值放在 created() 中
       */
      exportObj: {
        exportUrl:
          "ntocc-tms-api/mybankElectronicReceipt/exportElectronicReceipt", //导出接口
        name: "网商支付"
      },
      loading: false,
      tableData: [],
      errorData: [],
      parentData: {
        statusOptions: [],
        receipTypeOptions: []
      },
      modelEditFlag: false,
      modalTitle: "编辑",
      dialogTableVisible: false,
      electronicReceipt_search_button: false, //查询
      electronicReceipt_statusQuery_button: false, //更新申请结果
      electronicReceipt_show_button: false, //查看回单
      electronicReceipt_reapply_button: false, //重新申请
      listQuery: {
        gmtCreatedRange: "",
        pageNum: 1,
        pageSize: 10,
        sortField: "",
        sortType: "",
        total: 0
      },
      payTypeOptions: [
        {
          label: "托运人打款",
          value: "00"
        },
        {
          label: "托运人预付",
          value: "01"
        },
        {
          label: "平台打款",
          value: "10"
        },
        {
          label: "平台预付",
          value: "11"
        },
        {
          label: "来帐汇入",
          value: "5"
        }
      ],
      // 机构列表
      branchList: this.$store.state.components.branchList
    };
  },

  created() {
    /**
     * 下拉选项用“parentData”存放，便于向子组件传递
     */
    this.parentData.statusOptions = [
      { label: "处理中", value: "01" },
      { label: "成功", value: "02" },
      { label: "失败", value: "03" }
    ];
    this.parentData.receipTypeOptions = [
      { label: "单个", value: 0 },
      { label: "汇总", value: 1 }
    ];
    this.findList();
    this.electronicReceipt_search_button = getLimit(
      "electronicReceipt_search_button"
    );
    this.electronicReceipt_statusQuery_button = getLimit(
      "electronicReceipt_statusQuery_button"
    );
    this.electronicReceipt_show_button = getLimit(
      "electronicReceipt_show_button"
    );
    this.electronicReceipt_reapply_button = getLimit(
      "electronicReceipt_reapply_button"
    );
  },
  methods: {
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        mybankElectronicReceipt(this.listQuery, "get").then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 批量申请
    funcMultiApply() {
      const selectRecords = this.$refs.xTable.getCheckboxRecords();
      if (!selectRecords || selectRecords.length === 0) {
        this.$message({ message: "请选择需要申请项", type: "warning" });
      } else if (selectRecords.length > 100) {
        this.$message({ message: "批量处理最多100条数据", type: "warning" });
      } else {
        const rLoading = this.openLoading();
        const arr = selectRecords.map(item => {
          return {
            merchantId: item.merchantId,
            orderNo: item.orderNo,
            type: item.type
          };
        });
        applyMultiBatch(arr).then(response => {
          rLoading.close();
          let type = response.status === 0 ? "success" : "error";
          this.$message({
            message: response.msg,
            type: type
          });
          this.findList();
        });
      }
    },
    async PDFDownload(item) {
      let checkedRowArray = item
        ? [item]
        : this.$refs.xTable.getCheckboxRecords();
      if (!checkedRowArray || checkedRowArray.length === 0) {
        this.$message.warning("请选择需要打印的项");
        return false;
      } else if (checkedRowArray.length > 20) {
        this.$message.warning("批量处理最多20条数据");
        return false;
      }
      let codes = [];
      for (let subItem of checkedRowArray) {
        codes.push(subItem.code);
      }
      codes = codes.join(",");
      const rLoading = this.openLoading("正在打包请稍后...");
      let response = await downLoadFile({
        codes
        // isLocalHost:1
      });
      rLoading.close();
      this.$message.success(response.msg);
      window.open(response.data, "_blank");
    },
    // 翻译
    formatterField({ cellValue }, prefix) {
      if (this.parentData[`${prefix}Options`]) {
        const item = this.parentData[`${prefix}Options`].find(
          item => item.value === cellValue
        );
        return item ? item.label : "";
      } else {
        return "";
      }
    },
    showElectronicReceipt(row) {
      mybankElectronicReceiptInfo(row.receiptNo)
        .then(res => {
          let url = res.data.pdfDownloadUrl;
          window.open(url, "_blank");
        })
        .catch(res => {});
    },
    //重新申请电子回单
    reapplyReceiptStatus(row) {
      const rLoading = this.openLoading();
      mybankElectronicReceipt(
        {
          merchantId: row.merchantId,
          orderNo: row.orderNo,
          type: row.type
        },
        "post"
      ).then(response => {
        rLoading.close();
        let type = response.status === 0 ? "success" : "error";
        this.findList();
        this.$message({
          message: response.msg,
          type: type
        });
      });
    },
    //更新申请结果
    statusQuery() {
      const rLoading = this.openLoading();
      electronicReceiptQuery().then(response => {
        rLoading.close();
        if (response.status === 500) {
          this.dialogTableVisible = true;
          this.errorData = response.data;
        } else {
          let type = response.status === 0 ? "success" : "error";
          this.findList();
          this.$message({
            message: response.msg,
            type: type
          });
        }
      });
    }
  }
};
</script>
<style scoped>
.btnPicture {
  min-width: 140px;
  line-height: 40px;
  background: #1890ff;
  border-radius: 4px;
  padding: 10px 20px;
  font-family: PingFang SC;
  color: #ffffffff;
  cursor: pointer;
}
</style>
